<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{'--width': widthVar}" class="pageHeader">我的{{$store.state.themeTitle}}管理</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <!-- <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1"></OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择所属院系" style="width:320px;" @focus="dialogOpen1" @clear="handeleClear1" clearable></el-input>
        </el-form-item> -->
        <el-form-item label="审批状态">
          <el-select v-model="formInline.status" clearable filterable placeholder="请选择审批状态">
            <el-option v-for="item in $store.state.applyStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}名称`">
          <el-input v-model="formInline.name" clearable :placeholder="`请输入${$store.state.themeTitle}名称`"></el-input>
        </el-form-item>
        <!-- <el-form-item :label="`${$store.state.themeTitle}室名称`">
          <el-select v-model="formInline.training_room" clearable filterable :placeholder="`请选择${$store.state.themeTitle}室名称`">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name" :value="item.training_name"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增{{$store.state.themeTitle}}申请</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="downloadFile">下载实训导入模板</el-button>
        </el-form-item>
        <el-form-item>
          <Importt :uploadSectionFile="uploadSectionFile"  @refresh="handleQuery" :action="action" :params="params" :btnTitle="btnTitle"></Importt>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" :disabled="exportTitle=='导出中...'" @click="handleExportByUrl(formInline)">{{exportTitle}}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column fixed prop="name" label="实训名称" min-width="150">
        </custom-table-column>
        <custom-table-column prop="class_name" label="实训班级" width="160">
        </custom-table-column>
        <custom-table-column prop="oper_status" label="教研室主任审批状态" width="160">
          <template slot-scope="scope">
            <span v-if="scope.row.oper_status==''" style="color:var(--blue);">待审核</span>
            <span v-if="scope.row.oper_status=='pass'" style="color:var(--ligtGreen);">已通过</span>
            <span v-if="scope.row.oper_status=='refuse'" style="color:var(--red);">已拒绝</span>
          </template>
        </custom-table-column>
        <custom-table-column prop="oper_name" label="审核人" width="120">
        </custom-table-column>
        <custom-table-column prop="oper_status2" label="院系审核状态" width="160">
          <template slot-scope="scope">
            <span v-if="scope.row.oper_status2==''" style="color:var(--blue);">待审核</span>
            <span v-if="scope.row.oper_status2=='pass'" style="color:var(--ligtGreen);">已通过</span>
            <span v-if="scope.row.oper_status2=='refuse'" style="color:var(--red);">已拒绝</span>
          </template>
        </custom-table-column>
        <custom-table-column prop="oper_name2" label="审核人" width="120">
        </custom-table-column>
        <custom-table-column prop="username" label="指导老师" width="100">
        </custom-table-column>
        <custom-table-column prop="class_num" label="指导人数" width="100">
        </custom-table-column>
        <custom-table-column prop="term" label="学年学期" width="160">
        </custom-table-column>
        <custom-table-column prop="week" label="实训周次" width="100">
        </custom-table-column>
        <custom-table-column prop="week_num" label="总周次" width="100">
        </custom-table-column>
        <custom-table-column prop="xq" label="星期" width="100">
        </custom-table-column>
        <custom-table-column prop="xs" label="学时" width="100">
        </custom-table-column>
        <custom-table-column prop="training_room" :label="`所属${$store.state.themeTitle}室`" min-width="180">
        </custom-table-column>
        <custom-table-column prop="sssb" label="所需设备及工具" width="160">
        </custom-table-column>
        <custom-table-column prop="sshc" label="实训耗材" width="160">
        </custom-table-column>
        <custom-table-column prop="sxmd" label="实训目的与内容"  min-width="220">
        </custom-table-column>
        <custom-table-column prop="ssjh" label="实施计划安排"  min-width="220">
        </custom-table-column>
        <custom-table-column prop="sscg" label="实训成果"  min-width="220">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <!-- <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button> -->
            <el-button @click="handleEdit(scope.row,['school_Id','created_at','deleted_at'])" type="text" size="small">编辑</el-button>
            <el-button v-if="scope.row.status == 'apply'" @click="handleDelet(scope.row.id)" type="text" size="small">取消申请</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="766px">
      <!-- <OrganDialog ref="organDia" @getSelect="getSelect" :level="levell" @handleOrganQuery="handleOrganQuery"></OrganDialog> -->
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" class="demo-ruleForm">
        <el-form-item label="实训名称" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入实训名称" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="实训班级" prop="class_name">
          <el-input v-model="ruleForm.class_name" placeholder="请输入实训班级" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="班级人数" prop="class_num">
          <el-input v-model.number="ruleForm.class_num" placeholder="请输入班级人数" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="学年学期" prop="term">
          <el-select v-model="ruleForm.term" style="width:216px;" placeholder="请选择学年学期">
            <el-option v-for="item in $store.state.termms" :key="item.id" :label="item.term" :value="item.term"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="实训周次" prop="week">
          <el-input v-model="ruleForm.week" placeholder="请输入周次（格式1,3,4-7）" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="总周数" prop="week_num">
          <el-input v-model.number="ruleForm.week_num" placeholder="请输入总周数" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="星  期" prop="xq">
          <el-select v-model="ruleForm.xq" clearable placeholder="请选择星期" style="width:216px;">
            <el-option v-for="item in $store.state.weeks" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学时" prop="xs">
          <el-input v-model.number="ruleForm.xs" placeholder="请输入学时" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="实训地点" prop="training_room_id">
          <el-select v-model="ruleForm.training_room_id" filterable style="width:216px;" placeholder="请选择实训地点" @change="handleClassChange">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备及工具" prop="sssb">
          <el-input v-model="ruleForm.sssb" placeholder="请输入设备及工具" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="实训耗材" prop="sshc">
          <el-input v-model="ruleForm.sshc" placeholder="请输入实训耗材" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="实训目的与内容" prop="sxmd">
          <el-input type="textarea" v-model="ruleForm.sxmd" placeholder="请输入实训目的与内容" :rows="4" style="width:562px;"></el-input>
        </el-form-item>
        <el-form-item label="实施计划安排" prop="ssjh">
          <el-input type="textarea" v-model="ruleForm.ssjh" placeholder="请输入实施计划安排" :rows="4" style="width:562px;"></el-input>
        </el-form-item>
        <el-form-item label="实训成果" prop="sscg">
          <el-input type="textarea" v-model="ruleForm.sscg" placeholder="请输入实训成果" :rows="4" style="width:562px;"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="bz">
          <el-input type="textarea" v-model="ruleForm.bz" placeholder="请输入备注" :rows="4" style="width:562px;"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type=='add'" @click="submitFormByFun('ruleForm',createMethod)">确认</el-button>
          <el-button type="primary" v-if="type=='edit'" @click="submitFormByFun('ruleForm',updateMethod)">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
    <!-- <OrganDialog ref="organDia"></OrganDialog> -->
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
// import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinImport } from '@/assets/js/mixin/import';
// import { mixinValidate } from '@/assets/js/mixin/validate';

export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinImport],
  data() {
    return {
      formInline: {
        name: '',
        status: '',
      },
      selectName: '',
      organLabel: '',
      levell: [1, 2],
      ruleForm: {
        class_name: '',
        name: '',
        class_num: 0,
        week: '',
        week_num: 0,
        training_room: '',
        training_room_id: '',
        sssb: '',
        sshc: '',
        sxmd: '',
        ssjh: '',
        sscg: '',
        term:'',
        xs:'',
        bz:''
      },
      ruleForm1: {
        id: '',
        scrap_date: '',
      },
      numberDialogVisible: false,
      classRooms: [],
      rules: {
        name: [{ required: true, message: '请输入实训名称', trigger: 'blur' }],
        class_name: [{ required: true, message: '请输入实训班级', trigger: 'blur' }],
        class_num: [
          { required: true, message: '班级人数不能为空' },
          { type: 'number', message: '班级人数必须为数字值' },
        ],
        term: [{ required: true, message: '请输入学年学期', trigger: 'change' }],
        week: [{ required: true, message: '请输入实训周次', trigger: 'blur' }],
        week_num: [
          { required: true, message: '总周数不能为空' },
          { type: 'number', message: '总周数必须为数字值' },
        ],
        training_room_id: [{ required: true, message: '请选择实训地点', trigger: 'change' }],
        xq: [{ required: true, message: '请选择星期', trigger: 'change' }],
        sxmd: [{ required: true, message: '请输入实训目的与内容', trigger: 'blur' }],
        ssjh: [{ required: true, message: '请输入实施计划安排', trigger: 'blur' }],
        sscg: [{ required: true, message: '请输入实训成果', trigger: 'blur' }],
        xs: [
          { required: true, message: '学时不能为空' },
          { type: 'number', message: '学时必须为数字值' },
        ],
      },
      rules1: {
        scrap_date: [{ required: true, message: '请选择废弃时间', trigger: 'change' }],
      },
      numberDialogVisible1: false,
      ruleForm2: {
        goods_id: '',
        use_at: '',
        usage: '',
      },
      rules2: {
        use_at: [{ required: true, message: '请选择废弃时间', trigger: 'change' }],
        usage: [{ required: true, message: '请输入用途', trigger: 'blur' }],
      },
      action: '',
      downloadUrl: 'template/实训导入模版.xlsx',
      downloadName: '实训管理列表.xlsx',
      btnTitle: '导入实训数据',
      exportUrl: '',
    };
  },
  created() {
    // this.action = `${this.baseUrlt}api/danger_goods/import`;
    this.exportUrl = `${this.baseUrlt}api/sxgf/practical_training/apply/listMy?export=1`;
    this.$store.dispatch('getTarinMent');
    // this.$store.dispatch('getParams');
    this.$store.dispatch('getTermms');
  },
  computed: {
    total_price() {
      // this.total_price = this.quantity*this.price
      return (this.ruleForm.quantity * this.ruleForm.price * 1000) / 1000;
    },
  },
  mounted() {},
  methods: {
    handleDelet(id) {
      this.confirmBox('warning', `此操作将取消该申请，是否继续`, { id }, this.deleteMethod);
    },
    handleQuery() {
      // this.beforeQuery();
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    handleClassChange(e) {
      // this.ruleForm.room_id = e.id
      this.ruleForm.training_room = this.$until.getLabelName(this.$store.state.trainRooms, 'id', 'training_name', e);
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    async deleteMethod(params) {
      // let params = { id: this.delid };
      let res = await this.$api.instance.interfaceServer(`api/sxgf/practical_training/apply/delete/${params.id}`, 'post');
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '申请取消成功！',
        });
        this.handleQuery();
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.instance.interfaceServer('api/sxgf/practical_training/apply', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      let res = await this.$api.instance.interfaceServer(`api/sxgf/practical_training/edit/${this.ruleForm.id}`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/sxgf/practical_training/apply/listMy', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    handleEdit(row, filterArr = ['updated_at', 'deleted_at', 'created_at', 'login_time']) {
      if (row.structure_1 && row.major) {
        this.selectName = `${row.structure_1}-${row.major}`;
      }
      this.type = 'edit';
      this.title = '编辑';
      this.ruleForm = this.$until.delProp(row, filterArr);
      console.log(this.ruleForm);
      this.centerDialogVisible = true;
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
